import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { setDateForTable, setInputDate } from '../../../utils/date';
import { GeneralSettingsKeys, NavgationPageLocationKey } from '../../../utils/constants';
import ReactTable from 'react-table';
import { Button, Card, CardBody, CardHeader, Col, Container, DatePicker, FormInput, FormSelect, InputGroup, InputGroupAddon, InputGroupText, Row } from 'shards-react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Multiselect from 'multiselect-react-dropdown';
import { get_automation_process_list, get_process_list } from '../../../redux/actions/subscriber/automation';
import { get_pay_schedule_list } from '../../../redux/actions/subscriber/payroll';

const STATUS_ALL = 'All Statuses';
const PAYSCHEDULE_ALL = 'All Pay Schedules';
const AutomationLog = ({ get_process_list, get_pay_schedule_list, payScheduleList, processList
    , get_automation_process_list, automationLogList
 }) => {
    const initialState = {
        pageSizeOptions: [5, 10, 15, 20, 25, 30],
        pageSize: 10,
        from: '',
        to: '',
        refNum: '',
    }
    //const defaultStatus = [{ cat: '', key: '' }];
    const defaultStatus = [];
    const [state, setState] = useState({ ...initialState });
    const [statusDropdownOptions, setStatusDropdownOptions] = useState([]);
    const [selectedValues, setSelectedValues] = useState([...defaultStatus]);

    const defaultPaySchedule = [];
    const [payScheduleDropdownOptions, setPayScheduleDropdownOptions] = useState([]);
    const [selectedPaySchd, setSelectedPaySchd] = useState([...defaultPaySchedule]);

    const { pageSize, pageSizeOptions } = state;

    const [tableData, setTableData] = useState([]);
    const history = useHistory();

    const onChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };

    const tableColumns = [
        {
            Header: "Ref #",
            accessor: "refNum",
            maxWidth: 120, minWidth: 70,
            Cell: row => <>
                <a href="/automation-result-details" onClick={(e) => { openAutomationLogInNewTab(e, row.original.refNum) }}
                    onContextMenu={(e) => onContextMenuAutoLogChange(e, row.original.refNum)}>
                    {"RST-"}{row.original.refNum}
                </a>
            </>
        },
        {
            Header: "Process",
            accessor: "processName",
            minWidth: 130,
            classNames: 'text-center',
            Cell: row => <span className={row.original.processName !== "" ? "w-100 text-left" : "w-100"} title={row.original.processName}>
                {row.original.processName !== "" ? <span className="w-100 text-left" title={row.original.processName}> {row.original.processName} </span> : "--"}
            </span>
        },
        {
            Header: "Pay Schedule",
            accessor: "payScheduleName",
            minWidth: 100,
            classNames: 'text-left',
            Cell: row => <span className="w-100 text-left" title={row.original.payScheduleName}>{row.original.payScheduleName}</span>
        },
        {
            Header: "Invoice Date",
            accessor: "invoiceDate",
            minWidth: 100,
            maxWidth: 120,
            Cell: row => setDateForTable(row.original.invoiceDate)
        },
        {
            Header: "Due Date",
            accessor: "dueDate",
            maxWidth: 110, minWidth: 100,
            Cell: row => setDateForTable(row.original.dueDate)
        },
        {
            Header: "Date Actioned",
            accessor: "dateActioned",
            maxWidth: 120, minWidth: 110,
            Cell: row => setDateForTable(row.original.dateActioned)
        },
        {
            Header: "Status",
            accessor: "status",
            maxWidth: 130, minWidth: 100,
            Cell: row => <span className="w-100 text-left" title={row.original.status}>{row.original.status}</span>
        },
        {
            Header: "Action By",
            accessor: "actionedBy",
            minWidth: 100,
            maxWidth: 170,
            Cell: row => <span className="w-100 text-left" title={row.original.actionedBy}>{row.original.actionedBy}</span>
        },
    ]

    function navigateToAutomationLog(e, refId) {
        e.preventDefault();
        history.push({
            pathname: `/automation-result-details`,
            state: { refNum: refId }
        });
        return false;
    }

    function onContextMenuAutoLogChange(e, refId) {
        if (e.type === 'contextmenu') {
            localStorage.setItem(NavgationPageLocationKey.AutomationLogAddEdit, refId);
        }
    }

    function openAutomationLogInNewTab(e, refId) {
        e.preventDefault();
        localStorage.setItem(NavgationPageLocationKey.AutomationLogAddEdit, refId);
        window.open('/automation-result-details', '_blank');
    }

    const reset = () => {
        setState({ ...initialState })
        setSelectedValues([]);
        setSelectedPaySchd([]);
        get_automation_process_list( '', '', '', '', '');
    }

    const onSearch = (e) => {
        e.preventDefault()
        const selectedStatus = selectedValues.map(status => status.key).toLocaleString();
        let splitedRef = state.refNum.split('-');
        const refNum = splitedRef.length > 1 ? splitedRef[1] : state.refNum;
        const selectedPaySche = selectedPaySchd.map(status => status.key).toLocaleString();
        get_automation_process_list( refNum, selectedStatus, selectedPaySche, setInputDate(state.from), setInputDate(state.to));
    }

    useEffect(() => {
        let processStatus = processList.map(status => ({
            cat: status.processId,
            key: status.processName
        }))

        setStatusDropdownOptions([{
            cat: '',
            key: STATUS_ALL
        }, ...processStatus])
    }, [processList])

    useEffect(() => {
        let paySchedules = payScheduleList.map(status => ({
            cat: status.payScheduleRefNum,
            key: status.payScheduleName
        }))

        setPayScheduleDropdownOptions([{
            cat: '',
            key: PAYSCHEDULE_ALL
        }, ...paySchedules])
    }, [payScheduleList])

    useEffect(() => {
        setTableData([...automationLogList])
    }, [automationLogList])

    useEffect(() => {
        get_process_list();
        get_pay_schedule_list();
        get_automation_process_list( '', '', '', '', '');
    }, [])

    return (
        <Container fluid className="main-content-container px-4 pb-4">
            <div className="page-header tableSearch flex-column flex-md-row py-2 d-flex justify-content-end bg-white mt-4 ">

                <div className="d-flex align-items-center p-2">
                    <FormInput
                        name='refNum' value={state.refNum}
                        onChange={onChange} placeholder="Ref #"
                    />
                </div>

                <div className="d-flex align-items-center p-2">
                    <Multiselect
                        hideSelectedList
                        displayValue="key"
                        placeholder={`Process: ${(selectedValues && selectedValues.length > 0 && selectedValues[0].key === STATUS_ALL) ? STATUS_ALL : selectedValues.map(val => val.key).toString()}`}
                        onKeyPressFn={function noRefCheck() { }}
                        onSearch={function noRefCheck() { }}
                        onRemove={function noRefCheck(selectedOptions, item) {
                            if (item.key === STATUS_ALL) {
                                setSelectedValues([])
                            } else {
                                selectedOptions = selectedOptions.filter(option => option.key !== STATUS_ALL)
                                setSelectedValues([...selectedOptions])
                            }
                        }}
                        onSelect={function noRefCheck(selectedOptions, seletedItem) {
                            if (seletedItem.key === STATUS_ALL) {
                                setSelectedValues([...statusDropdownOptions])
                            } else {
                                if (selectedOptions.length === statusDropdownOptions.length - 1) {
                                    selectedOptions = [...statusDropdownOptions]
                                }
                                setSelectedValues([...selectedOptions])
                            }

                        }}
                        options={[
                            ...statusDropdownOptions
                        ]}
                        selectedValues={[...selectedValues]}

                        showCheckbox />
                </div>

                <div className="d-flex align-items-center p-2">
                    <Multiselect
                        hideSelectedList
                        displayValue="key"
                        placeholder={`Pay Schedule: ${(selectedPaySchd && selectedPaySchd.length > 0 && selectedPaySchd[0].key === PAYSCHEDULE_ALL) ? PAYSCHEDULE_ALL : selectedPaySchd.map(val => val.key).toString()}`}
                        onKeyPressFn={function noRefCheck() { }}
                        onSearch={function noRefCheck() { }}
                        onRemove={function noRefCheck(selectedOptions, item) {
                            if (item.key === PAYSCHEDULE_ALL) {
                                setSelectedPaySchd([])
                            } else {
                                selectedOptions = selectedOptions.filter(option => option.key !== PAYSCHEDULE_ALL)
                                setSelectedPaySchd([...selectedOptions])
                            }
                        }}
                        onSelect={function noRefCheck(selectedOptions, seletedItem) {
                            if (seletedItem.key === PAYSCHEDULE_ALL) {
                                setSelectedPaySchd([...payScheduleDropdownOptions])
                            } else {
                                if (selectedOptions.length === payScheduleDropdownOptions.length - 1) {
                                    selectedOptions = [...payScheduleDropdownOptions]
                                }
                                setSelectedPaySchd([...selectedOptions])
                            }

                        }}
                        options={[
                            ...payScheduleDropdownOptions
                        ]}
                        selectedValues={[...selectedPaySchd]}

                        showCheckbox />
                </div>
                
                <div className="d-flex align-items-center p-2">
                    <div className="d-flex align-items-center p-2">
                        <InputGroup className={classNames("d-flex", "my-auto", "date-range")}>
                            <DatePicker
                                name="from"
                                size="sm"
                                selected={state.from}
                                onChange={(date) => {
                                    setState({ ...state, from: date })
                                }}
                                dateFormat='yyyy-MM-dd'
                                placeholderText="From"
                                dropdownMode="select"
                                autoComplete='off'
                                className="text-center"
                            />
                            <DatePicker
                                name="to"
                                size="sm"
                                selected={state.to}
                                onChange={(date) => {
                                    setState({ ...state, to: date })
                                }}
                                dateFormat='yyyy-MM-dd'
                                placeholderText="To"
                                dropdownMode="select"
                                autoComplete='off'
                                className="text-center"
                                popperPlacement="top-end"
                            />
                            <InputGroupAddon type="append">
                                <InputGroupText>
                                    <i className="material-icons">&#xE916;</i>
                                </InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-end p-2">
                    <Button className="mx-2 py-2 my-2" size='sm' name="Search" theme="accent"
                        onClick={onSearch}>Search</Button>
                    <Button className="mx-2 py-2 my-2" size='sm' theme="accent" onClick={reset} >
                        Reset
                    </Button>
                </div>
            </div>

            <Card className="tableCard p-0">
                <CardHeader className="p-0">
                    <Container fluid className="file-manager__filters border-bottom">
                        <Row>
                            {/* Filters :: Page Size */}

                            <Col lg="2" className="file-manager__filters__rows d-flex justify-content-center justify-content-md-start align-items-center cl-2">
                            </Col>
                            <Col lg="3" className="d-flex align-items-center">
                            </Col>
                            <Col lg="6" className="file-manager__filters__search d-flex justify-content-md-start col-7">
                            </Col>

                            <Col lg="1"
                                className="file-manager__filters__rows d-flex justify-content-center justify-content-md-end align-items-center col-2">
                                <span>Show</span>
                                <FormSelect
                                    size="sm"
                                    name='pageSize'
                                    value={state.pageSize}
                                    onChange={onChange}
                                >
                                    {pageSizeOptions.map((size, idx) => (
                                        <option key={idx} value={size}>
                                            {size} rows
                                        </option>
                                    ))}
                                </FormSelect>
                            </Col>
                        </Row>
                    </Container>
                </CardHeader>
                <CardBody className="p-0">
                    <div className="">
                        <ReactTable
                            columns={tableColumns}
                            data={tableData}
                            pageSize={Number(pageSize)}
                            showPageSizeOptions={false}
                            resizable={false}
                            noDataText="No results found"
                            previousText={<i class='fa fa-chevron-left' aria-hidden='true'></i>}
                            nextText={<i class='fa fa-chevron-right' aria-hidden='true'></i>}
                        />
                    </div>
                </CardBody>
            </Card>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    processList: state.automation.processList,
    payScheduleList: state.payroll.payScheduleList,
    automationLogList: state.automation.automationLogList,
})

export default connect(mapStateToProps, {
    get_process_list,
    get_pay_schedule_list,
    get_automation_process_list,
})(AutomationLog)
